<template>
  <vertical-modal
    :visible="openModal"
    @close="closed"
    :header-title="`ویرایش اطلاعات پایه بار ${loadData?.id ?? ''}`"
    header-icon="info-bold"
    body-class="tw-bg-gray-100"
    width="md"
  >
    <template #body>
      <div class="tw-bg-white tw-rounded-[12px] tw-p-6 tw-mx-4 tw-my-4">
        <!-- سوئیچ ماهیت بار -->
        <div class="tw-mb-6">
          <p class="tw-mb-2 tw-text-sm tw-text-static-headerGray">ماهیت بار</p>
          <CircleToggle
            v-model="load_type"
            :options="loadTypeOptions"
            :size="30"
          />
        </div>

        <!-- حالت فاکتور فروش -->
        <template v-if="load_type === 'sale_invoice'">
          <div class="tw-block md:tw-grid md:tw-grid-cols-12 tw-gap-3 tw-mb-5">
            <div class="tw-w-full md:tw-col-span-6 tw-mb-6">
              <select-users
                title="مشتری"
                placeholder="مشتری را انتخاب کنید"
                icon="person"
                v-model="user_id"
              />
            </div>
            <div class="tw-w-full md:tw-col-span-6 tw-mb-6">
<!--              <base-select-->
<!--                title="سفارش متصل"-->
<!--                placeholder="سفارش متصل"-->
<!--                :float-title="true"-->
<!--                v-model="type_arz"-->
<!--                :options="priceUnits"-->
<!--              />-->
              <label
                class="tw-block tw-text-sm tw-mb-1 tw-text-static-headerGray"
              >
                سفارش متصل
              </label>
              <div
                class="tw-flex tw-items-center tw-gap-2 tw-h-[40px] tw-border tw-border-static-inputBorder tw-rounded-lg tw-px-3 tw-bg-gray-50"
              >
                <span class="tw-flex-1 tw-text-blue-dark-500" dir="ltr">
                  {{ related_order_id ?? '—' }}
                </span>
                <base-icon
                  icon="edit"
                  class="tw-cursor-pointer tw-text-blue-dark-400"
                />
              </div>
            </div>
          </div>
          <div class="tw-block md:tw-grid md:tw-grid-cols-12 tw-gap-3 tw-mb-5">
            <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
              <base-select
                title="واحد ارزی فروش"
                placeholder="انتخاب"
                :float-title="true"
                v-model="type_arz"
                :options="priceUnits"
              />
            </div>
            <template v-if="type_arz && type_arz !== 'IRR'">
              <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
                <input-ayandeh
                  v-model:value="price_arz"
                  :number-format="true"
                  :placeholder="'نرخ ' + (type_arz_label || '')"
                  dir="ltr"
                  :float-label="'نرخ ' + (type_arz_label || '') + ' (ریال)'"
                />
              </div>
              <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
                <input-ayandeh
                  v-model:value="price_per_ton_arz"
                  :placeholder="'فی فروش به ' + (type_arz_label || '')"
                  dir="ltr"
                  :float-label="'فی فروش (' + (type_arz_label || '') + ')'"
                />
              </div>
            </template>
            <div
              v-else-if="type_arz === 'IRR'"
              class="tw-w-full md:tw-col-span-4 tw-mb-6"
            >
              <input-ayandeh
                v-model:value="price_per_ton"
                placeholder="فی فروش"
                :number-format="true"
                dir="ltr"
                float-label="فی فروش (ریال)"
              />
            </div>
          </div>
        </template>

        <!-- حالت حواله انبار -->
        <template v-else-if="load_type === 'warehouse_transfer'">
          <div class="tw-block md:tw-grid md:tw-grid-cols-12 tw-gap-3 tw-mb-5">
            <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
              <label
                class="tw-block tw-text-sm tw-mb-1 tw-text-static-headerGray"
              >
                سفارش متصل
              </label>
              <div
                class="tw-flex tw-items-center tw-gap-2 tw-h-[40px] tw-border tw-border-static-inputBorder tw-rounded-lg tw-px-3 tw-bg-gray-50"
              >
                <span class="tw-flex-1 tw-text-blue-dark-500" dir="ltr">
                  {{ related_order_id ?? '—' }}
                </span>
                <base-icon
                  icon="edit"
                  class="tw-cursor-pointer tw-text-blue-dark-400"
                />
              </div>
            </div>
            <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
              <base-select
                title="انبار مبداء"
                placeholder="انتخاب انبار مبداء"
                :float-title="true"
                :loading="loadingWarehouses"
                v-model="origin_warehouse_id"
                :options="warehouseOptions"
                :disabled-options="[destination_warehouse_id]"
              />
            </div>
            <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
              <base-select
                title="انبار مقصد"
                placeholder="انتخاب انبار مقصد"
                :float-title="true"
                :loading="loadingWarehouses"
                v-model="destination_warehouse_id"
                :options="warehouseOptions"
                :disabled-options="[origin_warehouse_id]"
              />
            </div>
          </div>
        </template>

        <!-- فیلدهای مشترک -->
        <div class="tw-pt-2 tw-border-t tw-border-static-inputBorder2">
          <div
            class="tw-block md:tw-grid md:tw-grid-cols-12 tw-gap-3 tw-mb-5 tw-mt-4"
          >
            <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
              <base-select
                title="پرداخت کرایه توسط"
                placeholder="پرداخت کننده کرایه را انتخاب کنید"
                :float-title="true"
                v-model="rent_by"
                :options="rentByOptions"
              />
            </div>
            <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
              <input-ayandeh
                v-model:value="price_rent"
                placeholder="کرایه"
                :number-format="true"
                dir="ltr"
                float-label="کرایه (ریال)"
              />
            </div>
            <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
              <input-ayandeh
                v-model:value="price_reward"
                placeholder="انعام را وارد کنید"
                :number-format="true"
                dir="ltr"
                float-label="انعام (ریال)"
              />
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <new-btn variant="outline" color="primary" @click="closed">
        انصراف
      </new-btn>
      <new-btn
        color="primary"
        icon="save"
        :loading="saving"
        :disabled="saving"
        @click="handleSave"
      >
        ذخیره تغییرات
      </new-btn>
    </template>
  </vertical-modal>
</template>

<script setup>
import { ref, watch, computed, getCurrentInstance } from 'vue'
import VerticalModal from '@/components/base/VerticalModal.vue'
import NewBtn from '@/components/base/btn/NewBtn.vue'
import CircleToggle from '@/components/base/CircleToggle.vue'
import BaseSelect from '@/components/base/select/BaseSelect.vue'
import BaseIcon from '@/components/base/BaseIcon.vue'
import InputAyandeh from '@/components/inputs/InputAyandeh.vue'
import SelectUsers from '@/components/base/select/SelectUsers.vue'
import { priceUnits } from '@/services/more/ConstVar'
import { apiUpdateOrderBaseDetails } from '@/services/orders/Orders'
import { apiGetWarehouses } from '@/services/loads/LoadingService'

const props = defineProps({
  loadData: {
    type: Object,
    default: undefined,
  },
})

const emit = defineEmits(['close', 'saved'])

const openModal = defineModel({ type: Boolean, default: false })

const proxy = getCurrentInstance()?.proxy
const saving = ref(false)
const loadingWarehouses = ref(false)
const warehouses = ref([])

const loadTypeOptions = [
  { label: 'ماهیت فاکتور فروش', value: 'sale_invoice' },
  { label: 'ماهیت حواله انبار', value: 'warehouse_transfer' },
]

const rentByOptions = [
  { value: 'user', label: 'مشتری' },
  { value: 'ayandeh', label: 'شرکت آینده' },
]

// Form fields
const load_type = ref('sale_invoice')
const related_order_id = ref(null)
const user_id = ref(null)
const type_arz = ref('')
const price_arz = ref('')
const price_per_ton = ref('')
const price_per_ton_arz = ref('')
const origin_warehouse_id = ref(null)
const destination_warehouse_id = ref(null)
const rent_by = ref('')
const price_rent = ref('')
const price_reward = ref('')

const type_arz_label = computed(() => {
  return priceUnits.find((u) => u.value === type_arz.value)?.label ?? ''
})

const warehouseOptions = computed(() => {
  const list = warehouses.value || []
  return list.map((item) => ({
    value: item.Cod ?? item.id,
    label: item.Nam ?? item.title ?? item.name,
  }))
})

function closed() {
  openModal.value = false
  emit('close')
}

function fillForm(data) {
  if (!data) return
  load_type.value = data.load_type ?? 'sale_invoice'
  related_order_id.value =
    data.related_order_id ?? data.card_id ?? data.order_id ?? null
  user_id.value = data.user_id ?? null
  type_arz.value = data.type_arz ?? (data.price_per_ton ? 'IRR' : '')
  price_arz.value = data.price_arz
    ? proxy?.toNumberFormat?.(data.price_arz) ?? String(data.price_arz)
    : ''
  price_per_ton.value = data.price_per_ton
    ? proxy?.toNumberFormat?.(data.price_per_ton) ?? String(data.price_per_ton)
    : ''
  price_per_ton_arz.value = data.price_per_ton_arz ?? ''
  origin_warehouse_id.value =
    data.origin_warehouse_id ?? data.origin_warehouse ?? null
  destination_warehouse_id.value =
    data.destination_warehouse_id ?? data.destination_warehouse ?? null
  rent_by.value = data.rent_by ?? ''
  price_rent.value = data.price_rent
    ? proxy?.toNumberFormat?.(data.price_rent) ?? String(data.price_rent)
    : ''
  price_reward.value = data.price_reward
    ? proxy?.toNumberFormat?.(data.price_reward) ?? String(data.price_reward)
    : ''
}

async function getWarehouses() {
  loadingWarehouses.value = true
  try {
    const response = await apiGetWarehouses()
    if (!response?.data?.data) return
    warehouses.value = response.data.data
  } finally {
    loadingWarehouses.value = false
  }
}

function toRawNumber(val) {
  if (val == null || val === '') return null
  const str = String(val).replace(/[^0-9.]/g, '')
  const n = parseFloat(str)
  return isNaN(n) ? null : n
}

async function handleSave() {
  const loadId = props.loadData?.id ?? props.loadData?.load_id
  if (!loadId || !related_order_id.value) {
    proxy?.my_alert?.('شناسه بار و سفارش متصل الزامی است.', 'error')
    return
  }

  saving.value = true
  const payload = {
    load_id: Number(loadId),
    related_order_id: Number(related_order_id.value),
    load_type: load_type.value,
    rent_by: rent_by.value || undefined,
    price_rent: toRawNumber(price_rent.value) ?? undefined,
    price_reward: toRawNumber(price_reward.value) ?? undefined,
  }

  if (load_type.value === 'sale_invoice') {
    payload.user_id = user_id.value ? Number(user_id.value) : undefined
    payload.type_arz = type_arz.value || undefined
    payload.price_arz = toRawNumber(price_arz.value) ?? undefined
    payload.price_per_ton = toRawNumber(price_per_ton.value) ?? undefined
    payload.price_per_ton_arz =
      toRawNumber(price_per_ton_arz.value) ?? undefined
  } else {
    payload.origin_warehouse_id = origin_warehouse_id.value
      ? Number(origin_warehouse_id.value)
      : undefined
    payload.destination_warehouse_id = destination_warehouse_id.value
      ? Number(destination_warehouse_id.value)
      : undefined
  }

  try {
    const response = await apiUpdateOrderBaseDetails(payload)
    if (response?.data?.status === 'success') {
      emit('saved', response.data)
      closed()
    }
    proxy?.my_alert?.(
      response?.data?.message ?? '',
      response?.data?.status ?? 'info',
    )
  } catch (err) {
    proxy?.my_alert?.(err?.message ?? 'خطا در ذخیره', 'error')
  } finally {
    saving.value = false
  }
}

watch(
  () => [openModal.value, props.loadData],
  ([isOpen, data]) => {
    if (isOpen && data) {
      fillForm(data)
      if (data.load_type === 'warehouse_transfer') getWarehouses()
    }
  },
  { immediate: true },
)

watch(load_type, (val) => {
  if (val === 'warehouse_transfer' && !warehouses.value.length) getWarehouses()
})
</script>

<style lang="scss" scoped></style>
